import React from "react";
import { motion } from "framer-motion";
import clsx from "clsx";

export default function PrimaryButton({
  text,
  onClick,
  href,
  style,
  children,
  className = "",
  type = "button",
  disabled = false,
  animate = true,
}) {
  const baseClasses =
    "bg-primary text-card font-semibold py-2 px-4 rounded-lg shadow-md transition-colors duration-200";

  const hoverClasses = disabled
    ? "opacity-50 cursor-not-allowed"
    : "hover:bg-primary-dark active:bg-primary-light";

  const finalClasses = clsx(baseClasses, hoverClasses, className);

  const ButtonContent = (
    <motion.span
      whileTap={animate && !disabled ? { scale: 0.95 } : {}}
      className="flex items-center justify-center gap-2"
    >
      {children || text}
    </motion.span>
  );

  if (href) {
    return (
      <a href={href} className={finalClasses} style={style} onClick={onClick}>
        {ButtonContent}
      </a>
    );
  }

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      style={style}
      className={finalClasses}
    >
      {ButtonContent}
    </button>
  );
}
